import DatePicker from 'vue2-datepicker';

export default {
  name: 'projectDeadline',
  components: {
    DatePicker,
  },
  props: {
    dateTime: {
      default: '',
    },
  },
  data () {
    return {
      selectedProj: null,
      oldData: null,
      Request: {
        ID: null,
        DueDate: null,
      },
    };
  },
  methods: {
    calc () {
      var delta = new Date(this.dateTime * 1000) - new Date();
      var minutes = ~~(delta / (60 * 1000));
      var hours = ~~(minutes / 60);
      var days = ~~(hours / 24);
      minutes -= (hours * 60);
      hours -= (days * 24);
      var str = '';
      str += days !== 0 ? days + ' day(s) ' : '';
      str += hours !== 0 ? hours + ' hour(s) ' : '';
      str += minutes !== 0 ? minutes + ' minute(s)' : '';
      str += (delta >= 0 ? ' remaining' : ' after deadline');
      // var str = (days + ' days ' + hours + ' hours ' + minutes + ' minutes' + (days >= 0 && hours >= 0 && minutes >= 0 ? ' remaining' : ' after deadline'));
      return str.replace(/-/g, '');
    },
    timeSpanClass (dueDate) {
      var delta = dueDate - new Date();
      if (delta < 0) {
        return 'alert';
      } else if (delta < 604800000) {
        return 'warning';
      } else {
        return 'normal';
      }
    },
  },
};
